// extracted by mini-css-extract-plugin
module.exports = {"component":"_1zRiF","input":"U2BrO","icon":"GP2mO","loaderWrap":"_2KYXe","btnClearWrap":"_1dTtC","loader":"_1js3h","btnClear":"_11TeS"};